import "./src/styles/global.css"
import { initAnalytics, trackOutboundClicks, trackPageview } from "./src/analytics"

export const onClientEntry = () => {
  // Gatsby restores a page's last scroll position on a full page load, which is right for a
  // refresh or back/forward but not for a fresh visit: someone who scrolled Consulting earlier
  // and later follows a link to it would land at the old spot. Start fresh visits at the top.
  try {
    const nav = performance.getEntriesByType("navigation")[0]
    if (nav && nav.type === "navigate" && !window.location.hash) {
      sessionStorage.removeItem(`@@scroll|${window.location.pathname}|initial`)
    }
  } catch (e) {
    // sessionStorage can be blocked (private mode); Gatsby then has nothing to restore anyway.
  }
  initAnalytics()
  trackOutboundClicks()
}

// Fires on the first load and on every client-side route change.
export const onRouteUpdate = () => trackPageview()

// The site uses `scroll-behavior: smooth`, which turns Gatsby's jump-to-top on a page change
// into an animation that the new page interrupts, leaving visitors at the footer.
// Jump instantly instead: to the top for a new page, or to the saved spot on back/forward.
// Links with a #section still let Gatsby scroll to that section.
export const shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => {
  if (location.hash) return true
  const saved = getSavedScrollPosition(location)
  window.scrollTo({ top: saved ? saved[1] : 0, left: 0, behavior: "instant" })
  return false
}
